import { Link } from "react-router-dom";

const ListOrders = () => {
  // Example dummy data
  const orders = [
    { id: "101", title: "Order #101", date: "2025-09-01" },
    { id: "102", title: "Order #102", date: "2025-09-03" },
    { id: "103", title: "Order #103", date: "2025-09-05" },
    { id: "104", title: "Order #103", date: "2025-09-05" },
    { id: "105", title: "Order #103", date: "2025-09-05" },
    { id: "106", title: "Order #103", date: "2025-09-05" },
    { id: "107", title: "Order #103", date: "2025-09-05" },
  ];

  return (
    <div>
      {orders.map((order) => (
        <div key={order.id} className="order-card">
          <div className="order-info">
            <span className="order-id">{order.title}</span>
            <span className="order-date">{order.date}</span>
          </div>
          <div className="order-actions">
            <Link to={`${order.id}`} className="view">View</Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListOrders;
